export default __webpack_public_path__ + "static/media/longchamp10.83aa54d6.jpg";